<template>
  <div class="flex flew-row">
    <NumericInput
      :value="localHeightInFeet"
      min="0"
      max="8"
      aria-label="feet"
      inputId="heightMajor"
      :inputStyle="inputStyle"
      :measurement-indicator="measurementIndicators.feet"
      :disabled="disabled"
      @input="localHeightInFeet = $event"
      @blur="$emit('blur')"
    />
    <NumericInput
      :value="localHeightInInches"
      min="0"
      max="11"
      aria-label="inches"
      inputId="heightMinor"
      :inputStyle="inputStyle"
      :measurement-indicator="measurementIndicators.inches"
      :disabled="disabled"
      @input="localHeightInInches = $event"
      @blur="$emit('blur')"
    />
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import { validateInput } from "../../SimpleBmiQuestion/validation";
import { ImperialHeightMeasurementIndicators } from "../../../types";
import NumericInput from "./NumericInput.vue";

export default Vue.extend({
  components: { NumericInput },
  props: {
    heightInFeet: { type: Number, required: true },
    heightInInches: { type: Number, required: true },
    inputStyle: { type: String, required: true },
    measurementIndicators: { type: Object as PropType<ImperialHeightMeasurementIndicators>, required: true },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    localHeightInFeet: {
      get() {
        return this.heightInFeet;
      },
      set(value) {
        const emitValue = validateInput(value, 8);
        this.$emit("update:heightInFeet", emitValue);
      },
    },
    localHeightInInches: {
      get() {
        return this.heightInInches;
      },
      set(value) {
        const emitValue = validateInput(value, 11);
        this.$emit("update:heightInInches", emitValue);
      },
    },
  },
});
</script>
